/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Col,
  Form,
  Input,
  Row,
  Spin,
} from 'antd';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getPlaza } from 'api/catalogos/plazas';
import { getProyectoPresupuestales } from 'api/catalogos/ProyectoPresupuestal';

const EmpleadoDatosPresupuestales = ({
  form,
  empleado,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDatosPresupuestales = async () => {
      try {
        if (!empleado) return;
        setLoading(true);

        const [catalogosProyectos, datosOp] = await Promise.all([
          getProyectoPresupuestales(),
          getDatoOperacionalesDeEmpleados({ empleado }),
        ]);

        if (datosOp && datosOp.length > 0) {
          const dato = datosOp[0];

          if (dato.plaza) {
            const plazaData = await getPlaza(dato.plaza);

            if (plazaData) {
              // 1. Buscamos el proyecto en el catálogo usando el ID
              const proyectoId = plazaData.proyecto_presupuestal;
              const proyectoEncontrado = catalogosProyectos.find(
                (p) => p.id === proyectoId,
              );

              // 2. Concatenamos Proyecto Presupuestal (Clave - Descripción)
              const proyectoTexto = proyectoEncontrado
                ? `${proyectoEncontrado.clave} - ${proyectoEncontrado.descripcion}`
                : proyectoId;

              // 3. Concatenamos Tipo, Programa y Destino (Usando el ID como clave + Descripción)
              const tipoEmpleadoTexto = plazaData.tipo_de_empleado_presupuestal
               && plazaData.tipo_de_empleado_presupuestal_descripcion
                ? `${plazaData.tipo_de_empleado_presupuestal} - ${plazaData.tipo_de_empleado_presupuestal_descripcion}`
                : plazaData.tipo_de_empleado_presupuestal_descripcion
                || plazaData.tipo_de_empleado_presupuestal;

              const programaTexto = plazaData.programa_presupuestal
               && plazaData.programa_presupuestal_descripcion
                ? `${plazaData.programa_presupuestal} - ${plazaData.programa_presupuestal_descripcion}`
                : plazaData.programa_presupuestal_descripcion || plazaData.programa_presupuestal;

              const destinoTexto = plazaData.destino_presupuestal
              && plazaData.destino_presupuestal_descripcion
                ? `${plazaData.destino_presupuestal} - ${plazaData.destino_presupuestal_descripcion}`
                : plazaData.destino_presupuestal_descripcion || plazaData.destino_presupuestal;

              // 4. Asignamos los textos concatenados al formulario
              form.setFieldsValue({
                tipo_de_empleado_presupuestal: tipoEmpleadoTexto,
                programa_presupuestal: programaTexto,
                destino_presupuestal: destinoTexto,
                proyecto_presupuestal: proyectoTexto,
              });
            }
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[Datos Presupuestales] error al cargar datos de la plaza', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDatosPresupuestales();
  }, [empleado, form]);

  return (
    <Spin spinning={loading}>
      <Form
        layout="vertical"
        form={form}
        name="datos_presupuestales"
      >
        <Row gutter={16}>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              name="tipo_de_empleado_presupuestal"
              label="Tipo de Empleado Presupuestal"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <Form.Item
              name="programa_presupuestal"
              label="Programa Presupuestal"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <Form.Item
              name="destino_presupuestal"
              label="Destino Presupuestal"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <Form.Item
              name="proyecto_presupuestal"
              label="Proyecto Presupuestal"
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default EmpleadoDatosPresupuestales;
